import _ from '../../core/utils'

const HEADER_CONFIG = {
    el: _.select( '.header__main' ),
    background: _.select( '.header__main .background' ),
    hamburger: _.select( '.header__main .hamburger' ),
    hamburgerLines: _.selectAll( '.header__main .hamburger span' ),
    nav: _.select( '.header__main .bottom' ),
    pages: _.selectAll( '.header__main nav ul li' ),
    socialmedia: _.select( '.header__main .socialmedia' ),
    treshold: 200
}

export default HEADER_CONFIG